import { NavLink, useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const nav = [
  { to: "/admin", label: "Dashboard", end: true },
  { to: "/admin/new", label: "New Prayers" },
  { to: "/admin/circle", label: "Prayer Circle" },
  { to: "/admin/vigil", label: "Monday Vigil" },
  { to: "/admin/answered", label: "Answered Prayers" },
  { to: "/admin/updates", label: "Updates" },
  { to: "/admin/people", label: "People" },
  { to: "/admin/words", label: "Words for the Way" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = async () => { await logout(); navigate("/"); };

  return (
    <div className="min-h-screen bg-paper flex flex-col md:flex-row">
      <aside className="md:w-64 border-b md:border-b-0 md:border-r border-ink/15 md:min-h-screen">
        <div className="p-6 border-b border-ink/15">
          <NavLink to="/" className="font-heading text-xl text-ink leading-tight block">Ministry</NavLink>
          <span className="mono-label">Steward's desk</span>
        </div>
        <nav className="p-4 flex md:flex-col gap-1 overflow-x-auto">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase().replace(/ /g, "-")}`}
              className={({ isActive }) => `mono-label whitespace-nowrap px-3 py-2 ${isActive ? "bg-ink text-paper" : "hover:bg-paper-tertiary"}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 md:absolute md:bottom-0 md:w-64 border-t border-ink/15">
          <div className="font-body text-sm text-ink-secondary truncate">{user?.email}</div>
          <button onClick={onLogout} className="mono-label mt-2 underline underline-offset-4" data-testid="admin-logout">Sign out</button>
        </div>
      </aside>
      <div className="flex-1 min-w-0"><Outlet /></div>
    </div>
  );
}
